
import { SymbolData } from '../types';

export const starsData: SymbolData[] = [
  {
    id: 'star-peng',
    char: '蓬',
    pinyin: 'Tiān Péng',
    summary: '天蓬星：篷盖之水',
    tags: ['胆大好色', '蓬松遮盖', '属水', '大凶之星'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260204143316.png',
    story: '一个雨夜的桥洞下，躲着一位胆大好色的盗贼，他手里撑着一把破旧的伞（蓬盖），一头蓬松的乱发遮住了眼睛。虽然外表邋遢，但他眼神里透着水一般的狡黠与贪婪，正暗中盯着远处河边的豪宅，盘算着今晚的“猎艳”与“冒险”。天蓬之象，便是这暗处滋生的欲望与危机。',
    coreOrigins: [
      {
        title: '核心原点 ①：胆大好色',
        logic: '对应北斗九星之贪狼星。在道教中它叫贪狼，代表欲望、生机与祸福之首。贪狼主灵气与贪念，所以天蓬星的人通常胆大妄为、聪明绝顶。',
        subItems: [
          { label: '概念', content: '聪明智慧、大胆妄为、心狠手辣、贪恋酒色。' },
          { label: '人物', content: '妓女、盗贼、乞丐、黑社会、猎鱼者、投机倒把者。' },
          { label: '性情', content: '圆融果敢、大胆妄为、贪婪、敢于冒险、喜欢暗中行事、多情多欲、贪酒恋花。' },
        ],
      },
      {
        title: '核心原点 ②：蓬 → 蓬松、覆盖与庇护',
        logic: '源于“篷”的意象，引申为遮盖、蓬松之物。',
        subItems: [
          { label: '人物', content: '头发蓬松的人。' },
          { label: '形态', content: '庄严、威猛、彪悍、精干、面黑或眼大。' },
          { label: '人体', content: '头发、足部。' },
          { label: '动物', content: '多毛多厚的动物。' },
          { label: '植物', content: '磨菇类、菌类植物、树冠大的树、大叶植物、蓬草类、刚出土的植物。' },
          { label: '静物', content: '伞、雨具、渔具、船、车。' },
          { label: '地理', content: '宫殿、亭子、庙宇、茅屋、简陋的房屋、四面通风的房子、破了门窗的房子、房顶、三角状的建筑、桥等。' },
        ],
      },
      {
        title: '核心原点 ③：属水',
        logic: '五行属水，主阴暗、流动、肾脏系统。',
        subItems: [
          { label: '人体', content: '耳、肾、膀胱、生殖系统、排泄系统、眼睛。' },
          { label: '动物', content: '猪、鼠、蝙蝠、水生物等。' },
          { label: '方位/天时/色彩', content: '北方；阴天、雨天、多云的天气、黑夜、冬天；黑色、蓝色、玄色。' },
        ],
      },
    ],
  },
  {
    id: 'star-ren',
    char: '任',
    pinyin: 'Tiān Rèn',
    summary: '天任星：厚土承任',
    tags: ['任劳任怨', '属土'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260204143216.png',
    story: '金秋的东北梯田上，一位驼背的老农民正背着沉重的谷穗缓缓行走。他皮肤黝黑，神情敦厚，虽然背压得弯弯的，但脚下的步子踩在厚实的黄土上却异常稳健。他任劳任怨地耕耘了一辈子，像一座沉默的山丘，承载着一家人的生计与希望——这就是天任星的厚德载物。',
    coreOrigins: [
      {
        title: '核心原点 ①：任 → 任劳任怨、驼背与承载',
        logic: '源于“任”的承担之意，引申为负重、担当和生理上的驼背。',
        subItems: [
          { label: '概念', content: '担当、承受、任劳任怨、任重道远。' },
          { label: '人物', content: '驼背人、怕老婆、老诗人、长者、寿星、辛苦劳碌之人。' },
          { label: '形态', content: '弯腰驼背。' },
          { label: '性情', content: '忠厚老实、任劳任怨、倔强、勤奋，有韧性但固执、保守、小气、缺乏开拓精神。' },
          { label: '人体', content: '手、腰、脊椎、腿。' },
          { label: '静物', content: '桌子、椅子、被子、车子、柜子、鞋子。（注解：皆为承载之物）' },
          { label: '地理', content: '桥、台阶、门槛。' },
        ],
      },
      {
        title: '核心原点 ②：土 → 农民、敦厚与孕育',
        logic: '天任星五行属土，对应八卦中的艮土，主山、止、敦厚。',
        subItems: [
          { label: '人物', content: '农民（农业生产者）、地产商、种植业者、矿山开采者、登山者、建筑者。' },
          { label: '形态', content: '胸部丰满、方脸重眉。' },
          { label: '人体', content: '鼻（注解：面部中岳）、胃、脾、腹部、男性生殖器、乳房。' },
          { label: '动物', content: '肥大憨厚的牛、骆驼、虎、豹、狗、狼、猪、山中的动物。' },
          { label: '植物', content: '农产品，山果，谷穗、稻子、黍子、葵花。' },
          { label: '地理', content: '山丘、土包、丘陵、梯田、起伏不平的路等。' },
          { label: '方位/天时/色彩', content: '东北方；云、雾、风沙；黄色。' },
        ],
      },
    ],
  },
  {
    id: 'star-chong',
    char: '冲',
    pinyin: 'Tiān Chōng',
    summary: '天冲星：雷木之冲',
    tags: ['冲', '直木'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260204150423.png',
    story: '古战场上，一声惊雷炸响，一位身材瘦长挺拔如直木的武士，手持长枪，像离弦之箭一样冲向敌阵。他性情急躁，行动如风，身后战鼓雷动，喊杀声震天。他不顾一切地冲击着敌人的防线，那股雷厉风行的劲头，正是天冲星“雷木之冲”的完美写照。',
    coreOrigins: [
      {
        title: '核心原点 ①：冲 → 冲动、冲击与速度',
        logic: '天冲雷神，虽主惊恐，亦助威势。利于出师征伐，报仇雪耻。',
        subItems: [
          { label: '概念', content: '冲动、直往前闯、冲击、猛烈、矛盾。' },
          { label: '人物', content: '雷公、武士、警察、军人、报复者、证人、挑起事端者、田径运动员、武术爱好者。' },
          { label: '性情', content: '性子急、工作麻利、为人爽快、敢打敢冲、好出风头、不稳重、好冲动、做事多为欠思考、雷厉风行。' },
          { label: '动物', content: '天上飞的，会蹦的兔子、天鹅、燕子、鹰鹫、跳蚤、蟋蟀、蝗虫、蚱蜢。' },
          { label: '静物', content: '乐器、音响、钟、铃、枪炮、剑、汽车、飞机、弹药、鞭炮。' },
          { label: '地理', content: '交通枢纽、交通要道、机场、车站、公安局、派出所、噪音大的场所。' },
          { label: '天时', content: '雷电、冰雹、海啸、地震、风。' },
        ],
      },
      {
        title: '核心原点 ②：直木 → 挺拔、高大与新生',
        logic: '五行属木，且为震木，主高大、直立。',
        subItems: [
          { label: '形态', content: '直、高、长方脸、长发、身体瘦长。' },
          { label: '人体', content: '肝、筋骨、发、大腿、神经、气管。' },
          { label: '动物', content: '蛇（注解：形态细长，攻击时呈直线）。' },
          { label: '植物', content: '直冲云霄直线的 竹、树、高粱、玉米。' },
          { label: '地理', content: '高大建筑物、公园。' },
          { label: '方位/色彩', content: '东；碧绿。' },
        ],
      },
    ],
  },
  {
    id: 'star-fu',
    char: '辅',
    pinyin: 'Tiān Fǔ',
    summary: '天辅星：文德之辅',
    tags: ['辅助', '阴木', '文化'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260204143756.png',
    story: '东南方的林荫道旁，一位文雅的教师站在垂拂的柳树（阴木）下，手持书卷，耐心地辅导着学生。微风拂过，绿叶轻摇，正如他谦虚温和的教诲，如春风化雨般滋润心田。这里没有喧嚣，只有文化的传承与辅助成长的力量——这就是天辅星的文德之辅。',
    coreOrigins: [
      {
        title: '核心原点 ①：辅助 → 帮助、辅佐与服务',
        logic: '源于“辅”的本意，辅助、佐助。',
        subItems: [
          { label: '概念', content: '帮助、辅佐、协助、指导、推荐。' },
          { label: '人物', content: '总理、策划人、秘书、祝寿、导游、指导员、辅助人员。' },
          { label: '静物', content: '帮助人的空调、风扇、窗口、绳子、电线、窗帘、衣服、筷子、桌椅、板凳、家具、雨衣、伞、床。' },
          { label: '地理', content: '围墙、栅栏、隔离带、护栏、林荫路。' },
        ],
      },
      {
        title: '核心原点 ②：阴木 → 温和、柔顺与植物',
        logic: '五行属木，且为巽木（阴木），主柔顺、风。',
        subItems: [
          { label: '形态', content: '身体细长、发缜密、脸青白、手细长。' },
          { label: '性情', content: '谦虚、仁慈面善、和谐融洽、柔顺。' },
          { label: '人体', content: '大腿、呼吸器官、食道、神经、头发（注解：取其柔顺缜密之象）。' },
          { label: '动物', content: '温顺的鸡、蛇、鸭、泥鳅、蚯蚓、蝴蝶、蜻蜓。' },
          { label: '植物', content: '柳树、葡萄、葫芦、丝瓜、南瓜、杨树（柔顺、蔓藤类）。' },
          { label: '方位/天时/色彩', content: '东南；风、旋风、彩虹、祥云；绿色。' },
        ],
      },
      {
        title: '核心原点 ③：文化 → 文曲、科甲与修养',
        logic: '对应北斗九星之文曲星。象征人物为孔子或文昌帝君，主文化、教育、科甲。',
        subItems: [
          { label: '来源', content: '源自文曲星（天权），主管文运与科甲。' },
          { label: '概念', content: '文化、教育、文运、科甲、艺术才华。' },
          { label: '人物', content: '教师、教授、文化人、大文豪、大学生、博士。' },
          { label: '性情', content: '文雅、有修养、有文化、有风度、君子之风。' },
          { label: '静物', content: '书籍、文具、毕业证、文件、画作。' },
          { label: '地理', content: '学校、考场、文化馆、图书馆。' },
        ],
      },
    ],
  },
  {
    id: 'star-ying',
    char: '英',
    pinyin: 'Tiān Yīng',
    summary: '天英星：火之华彩',
    tags: ['火', '漂亮', '英雄'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260204143849.png',
    story: '正午的南方，烈日当空，一座宏伟的舞台上，一位打扮漂亮的演员正在表演。背景是绚烂的烟花（火）与霓虹灯，她如同孔雀开屏般耀眼，展现出英雄般的自信与才华。但这光芒太过热烈与焦躁，稍有不慎便会引发“火灾”或虚荣的泡沫——这就是天英星的火之华彩。',
    coreOrigins: [
      {
        title: '核心原点 ①：火 → 热烈、光明与能量',
        logic: '五行属火，主光明、热烈、焦躁。',
        subItems: [
          { label: '五行', content: '火。' },
          { label: '性情', content: '声音焦脆、焦躁不安、易怒。' },
          { label: '人体', content: '眼睛（采光）、血液（红色，热能）、心脏、小肠。' },
          { label: '静物', content: '爆炸易燃物品、家用电器、烟花爆竹、太阳、霓虹灯、灯具。' },
          { label: '地理', content: '高亢之地、阳光充足的场所、炉冶之地。' },
          { label: '方位/天时/色彩', content: '南方；晴天、夏天、中午、闪电；红色。' },
        ],
      },
      {
        title: '核心原点 ②：漂亮 → 美丽、艺术与文采',
        logic: '火主礼，也主绚丽多彩，引申为漂亮、装饰。',
        subItems: [
          { label: '概念', content: '秀丽、美丽。' },
          { label: '人物', content: '文艺工作者、演员、导演、画家、美容美发、作家。' },
          { label: '形态', content: '瓜子脸、面红白、身体瘦、头发较黄。' },
          { label: '动物', content: '孔雀、鹦鹉、火鸡、金鱼、热带鱼、等一切漂亮的动物。' },
          { label: '植物', content: '开花的植物、盆景、花卉。' },
          { label: '静物', content: '影视用品、证件、图片、图书。' },
          { label: '地理', content: '美容院、语言学校、电影院、百货店、图书馆。' },
        ],
      },
      {
        title: '核心原点 ③：英雄 → 卓越、智慧与杰出',
        logic: '英者，华彩也，亦为英雄、精英。',
        subItems: [
          { label: '概念', content: '卓越、杰出、贤明、智勇。' },
          { label: '人物', content: '掌握核心技术的精英、电子产品经营制造者。' },
          { label: '性情', content: '礼貌虚伪（注解：高情商、善于社交的表现）。' },
        ],
      },
    ],
  },
  {
    id: 'star-rui',
    char: '芮',
    pinyin: 'Tiān Ruì',
    summary: '天芮星：坤土之疾',
    tags: ['问题', '解决问题', '联合', '病灶'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260204143958.png',
    story: '在一所古老的医院（也是医学院）里，一位大腹便便的医生（老师）正在给学生们讲课。他指着黑板上的人体图，分析着胃部的病灶（问题）。窗外是连绵的农田（土），几个朋友正联合在一起收割庄稼。天芮星既是那令人担忧的“病”，也是传道授业、试图解决问题的“师”。',
    coreOrigins: [
      {
        title: '核心原点 ①：问题 → 病灶、错误与缺陷',
        logic: '为什么叫“芮”？因为草木萌芽（芮）时最容易产生病虫害，也最需要吸收养分。所以天芮星被定为“病星”。',
        subItems: [
          { label: '概念', content: '问题、毛病、错误。' },
          { label: '人物', content: '病人、产妇（注解：处于特殊的生理病理期）。' },
          { label: '性情', content: '固执、迟钝、懦弱、阴险毒辣、贪婪无耻（精神上的“疾病”）。' },
        ],
      },
      {
        title: '核心原点 ②：解决问题的人 → 师者、医者与管理者',
        logic: '因为有“问题”，所以衍生出“解决问题”的角色，如老师（解决知识问题）、医生（解决健康问题）。',
        subItems: [
          { label: '人物', content: '教师、医生、图书管理。' },
          { label: '地理', content: '学校、书店、医院（解决问题的场所）。' },
          { label: '静物', content: '书籍（解决问题的工具）。' },
        ],
      },
      {
        title: '核心原点 ③：联合 → 交往、结交与群体',
        logic: '天芮授道结交宜，引申为朋友、联合。',
        subItems: [
          { label: '概念', content: '联合、结交。' },
          { label: '人物', content: '朋友、学生。' },
          { label: '地理', content: '庭院、走廊、街道（人群交往的场所）。' },
        ],
      },
      {
        title: '核心原点 ④：土 → 孕育、承载与田土',
        logic: '五行属土，对应坤卦。',
        subItems: [
          { label: '人物', content: '女神、大腹人（形态）、种田人、孕妇、地产持有人。' },
          { label: '形态', content: '方脸、大嘴、肚子大、面色较黄、有雀斑。' },
          { label: '人体', content: '脾、胃、腹部、肩部、嘴部。' },
          { label: '植物', content: '庄稼、农作物、土豆、地瓜。' },
          { label: '静物', content: '菩萨、女神（大地母亲的象征）、瓦罐、瓷器。' },
          { label: '方位/天时/色彩', content: '西南；云、雾气、黄沙；黄色。' },
        ],
      },
    ],
  },
  {
    id: 'star-zhu',
    char: '柱',
    pinyin: 'Tiān Zhù',
    summary: '天柱星：破军金声',
    tags: ['中流砥柱', '柱状', '声音', '好斗'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260204144316.png',
    story: '荒凉的秋风中，一根孤零零的高塔（柱状）矗立在废墟上，像一位中流砥柱的战士。塔顶的大喇叭发出刺耳的声音，播报着破坏与战争的消息（破军）。一位律师站在塔下，用激昂的言辞进行着最后的辩护，试图在崩塌的秩序中寻找支点。天柱星，就是这根在风雨中发出金石之音的“破军之柱”。',
    coreOrigins: [
      {
        title: '核心原点 ①：中流砥柱 → 支撑、顶立与中坚',
        logic: '“柱”有支撑之意，引申为顶天立地、中流砥柱。',
        subItems: [
          { label: '概念', content: '顶天立地、力挽狂澜、中流砥柱、能独当一面。' },
          { label: '人物', content: '职业军警（国家的支柱）。' },
          { label: '形态', content: '身体健壮。' },
        ],
      },
      {
        title: '核心原点 ②：柱状 → 挺拔、细长与直立',
        logic: '源于“柱”的物理形态。',
        subItems: [
          { label: '人体', content: '中直部位、颈椎、腰椎、手指、大腿（身体的“柱状”支撑部分）。' },
          { label: '植物', content: '直的树、芦苇、毛竹、胡杨。' },
          { label: '地理', content: '钢管、水泥管、烟囱、线管、高塔、水塔、大厦、电线杆。' },
        ],
      },
      {
        title: '核心原点 ③：声音 → 能言、善辩与发声',
        logic: '其象为“破军金声”，天柱星在兑宫，属金，也有声音的意思。',
        subItems: [
          { label: '概念', content: '口舌是非。' },
          { label: '人物', content: '教师、律师、娱乐演艺人员、歌手。' },
          { label: '性情', content: '能说会道、为能言善辩。' },
          { label: '静物', content: '乐器、音响、喇叭、钟表（报时）、发声的物体。' },
        ],
      },
      {
        title: '核心原点 ④：好斗（负面） → 惊怪与破坏',
        logic: '对应北斗九星之破军星。它主破坏、开创、先遣。',
        subItems: [
          { label: '五行', content: '金。' },
          { label: '概念', content: '惊恐怪异、好战、破坏毁折。' },
          { label: '人物', content: '检查官、纪检人员。' },
          { label: '性情', content: '好斗争讼。' },
          { label: '方位/天时/色彩', content: '西；秋天（肃杀）、雷电、冰雹；白色。' },
        ],
      },
    ],
  },
  {
    id: 'star-xin',
    char: '心',
    pinyin: 'Tiān Xīn',
    summary: '天心星：乾金之心',
    tags: ['心计', '中心', '仁心'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20260204144418.png',
    story: '在西北方向的一座宏伟宫殿（中心）里，一位威严的领袖（或名医）正在审视地图，他运用心计与智慧策划着国家的未来。他身旁放着金银财宝与草药，时刻准备着赏赐功臣或医治百姓。他就是那个核心，那颗跳动的“天心”，以乾金之刚健，行仁慈之大得。',
    coreOrigins: [
      {
        title: '核心原点 ①：心计 → 思想、策划与智慧',
        logic: '对应北斗九星之武曲星。象征人物为姜子牙或诸葛亮，身为帝王师，运筹帷幄，决胜千里，且心怀天下，济世救人。',
        subItems: [
          { label: '概念', content: '思想活动、想法、情感、策划。' },
          { label: '人物', content: '参谋助手、医卜星象之人。' },
          { label: '性情', content: '聪明能干、精明机智、有领导才能、攻于心计、阴柔细腻、策划周密。' },
          { label: '人体', content: '头、心脏（思想与情感中枢）。' },
        ],
      },
      {
        title: '核心原点 ②：中心 → 领导、权威与核心',
        logic: '心为一身之主，引申为核心、中心、领导。',
        subItems: [
          { label: '概念', content: '宇宙的中心。' },
          { label: '人物', content: '领导、管理人员、指挥人员、核心人物。' },
          { label: '形态', content: '圆形、高大、威严、雄伟。' },
          { label: '地理', content: '领导办公室、影碑墙、堂屋、塔、大平原。' },
        ],
      },
      {
        title: '核心原点 ③：仁心 → 医治、神佛与善行',
        logic: '天心为吉星，有救死扶伤、慈悲为怀之意。',
        subItems: [
          { label: '人物', content: '医生、医药。' },
          { label: '性情', content: '乐善好施、能惩恶助善。' },
          { label: '植物', content: '菊花（药用）、草药。' },
          { label: '静物', content: '神像、佛像。' },
          { label: '地理', content: '教堂、寺院。' },
        ],
      },
      {
        title: '核心原点 ④：金 → 贵重、刚健与收获',
        logic: '五行属金，对应乾金。',
        subItems: [
          { label: '五行', content: '金。' },
          { label: '静物', content: '金、银、珍珠、贵重物品。' },
          { label: '方位/天时/色彩', content: '西北；冰雹、霜、雪；白色、金色。' },
        ],
      },
    ],
  },
];
